import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStopwatch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStopwatch"><Path d="M15 1H9V3H15V1Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.02944 7.02944 4 12 4C16.9706 4 21 8.02944 21 13ZM9 8.58579L13.4142 13L12 14.4142L7.58579 10L9 8.58579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStopwatch;
